import React from 'react'
import { BUS_BODY_WORK_PATH } from "../../../../config/paths";
import Loader from "../../../common/Loader";
import NoDataResource from "../../../common/resource/NoDataResource";
import Content from "../../../layout/Content";
import PropTypes from 'prop-types';
import { breadcrumbsPropTypes, matchPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { useLayoutEffect } from 'react';
import BusBodyworkForm from './BusBodyworkForm';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { clearBusBodyWork, getBusBodyWork, putBusBodyWork } from '../../../../actions/bus/BusBodyWork';

const EditBusBodywork = ({
    breadcrumbs,
    dispatchGetBusBodywork,
    dispatchClearBusBodywork,
    dispatchPutBusBodywork,
    match: {
        params: { id: busBodyWorkId },
    },
    loading,
    busBodyWork,
}) => {
    useLayoutEffect(() => {
        dispatchGetBusBodywork({ busBodyWorkId });

        return () => dispatchClearBusBodywork();
    }, []);

    const onSubmit = (formValues) => {
        const newFormValues = { ...formValues };

        dispatchPutBusBodywork(busBodyWorkId, newFormValues);
    };

    const generateInitialValues = ({
        make,
        model,
        year,
        fuelCapacity
    }) => {
        return {
            make,
            model,
            year,
            fuelCapacity
        };
    };

    let content;

    if (loading) content = <Loader />;
    else if (busBodyWork.isEmpty())
        content = <NoDataResource returnPage={BUS_BODY_WORK_PATH} />;
    else
        content = (
            <BusBodyworkForm
                onSubmit={onSubmit}
                initialValues={generateInitialValues(busBodyWork.toJS())}
            />
        );

    return (
        <Content
            breadcrumbs={breadcrumbs}
            title="Editar Carrocería"
            subtitle="Editar carrocería"
            content={content}
        />
    );
};

EditBusBodywork.propTypes = {
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    dispatchClearBusBodywork: PropTypes.func.isRequired,
    dispatchGetBusBodywork: PropTypes.func.isRequired,
    dispatchPutBusBodywork: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    match: matchPropTypes.isRequired,
    busBodyWork: PropTypes.instanceOf(Immutable.Map).isRequired,
};

EditBusBodywork.defaultProps = {
    loading: false,
};

const mapDispatchToProps = {
    dispatchClearBusBodywork: clearBusBodyWork,
    dispatchGetBusBodywork: getBusBodyWork,
    dispatchPutBusBodywork: putBusBodyWork,
};

const mapStateToProps = (
    { BusUnit },
    {
        match: {
            params: { id },
        },
    },
) => ({
    breadcrumbs: [
        ...BusUnit.UnitHome.get('breadcrumbs'),
        {
            text: 'Carrocerías',
            href: BUS_BODY_WORK_PATH,
        },
        {
            text: 'Ver',
            href: `${BUS_BODY_WORK_PATH}/${id}`,
        },
        {
            text: 'Editar',
            href: '',
        },
    ],
    busBodyWork: BusUnit.BusBodyWork.getIn(['current', 'content']),
    loading: !BusUnit.BusBodyWork.getIn([
        'current',
        'activity',
    ]).isEmpty(),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBusBodywork);
